/**
 * Documentos fiscais (PRD §17; docs/mega-panel.md, gate de cadastro).
 *
 * Validação por dígito verificador, sem consulta externa: o objetivo é impedir o
 * cadastro com um número inventado, não atestar a existência da empresa. Vive em
 * `@talkium/types` porque console e API precisam concordar — o mesmo algoritmo dos dois
 * lados é o que evita um formulário que aceita o que o servidor recusa.
 */
export function onlyDigits(value) {
    return value.replace(/\D/g, '');
}
export function isValidCpf(value) {
    const digits = onlyDigits(value);
    if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits))
        return false;
    const check = (length) => {
        let sum = 0;
        for (let i = 0; i < length; i += 1)
            sum += Number(digits[i]) * (length + 1 - i);
        const rest = (sum * 10) % 11;
        return rest === 10 ? 0 : rest;
    };
    return check(9) === Number(digits[9]) && check(10) === Number(digits[10]);
}
export function isValidCnpj(value) {
    const digits = onlyDigits(value);
    if (digits.length !== 14 || /^(\d)\1{13}$/.test(digits))
        return false;
    const check = (length) => {
        const weights = length === 12
            ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
            : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        for (let i = 0; i < length; i += 1)
            sum += Number(digits[i]) * weights[i];
        const rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
    };
    return check(12) === Number(digits[12]) && check(13) === Number(digits[13]);
}
/** CPF ou CNPJ válido, pelo tamanho. `null` quando não é nenhum dos dois. */
export function documentKind(value) {
    const digits = onlyDigits(value);
    if (digits.length === 11)
        return isValidCpf(digits) ? 'CPF' : null;
    if (digits.length === 14)
        return isValidCnpj(digits) ? 'CNPJ' : null;
    return null;
}
export function formatDocument(value) {
    const digits = onlyDigits(value);
    if (digits.length === 11) {
        return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    if (digits.length === 14) {
        return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return value;
}
//# sourceMappingURL=document.js.map